import { IActivityInitialState } from "../../../types/sales/activityInterface";
import { ActivityActionTypes, ActivityActions } from "../../actionTypes/sales/activityActionTypes";

const initialState: IActivityInitialState = {
  activityList: [],
  activityData: {
    id: 0,
    title: "",
    target_type: "",
    target_code: "",
    assigned_to: 0,
    event_type: "",
    event_date: "",
    location: "",
    agenda: "",
    activity_status: "",
    cancel_reason: "",
    created_by: 0,
    createdAt: "",
    note: "",
    lead: {
      lead_code: "",
      status: "",
      source: "",
      industry: "",
      referred_by: 0,
      created_by: 0,
      createdAt: "",
      updatedAt: "",
      assigned_to: 0,
      contact_person: "",
      contact_person_designation: "",
      tags: "",
      email: "",
      pincode: 0,
      address: "",
      website: "",
      contact_number: "",
      alternate_contact_number: "",
      company_name: "",
      customer_business_potential: 0,
      tqs_wallet_share: 0,
      description: "",
      pincode_data: {
        id: 0,
        pincode: 0,
        district: {
          district_name: "",
          state: {
            state_name: "",
          },
        },
      },

    },
    customer: {
      id: 0,
      customer_code: "",
      company_name: "",
      contact_person: "",
      contact_person_designation: "",
      contact_number: "",
      parent_customer_id: 0,
      email: "",
      company_id: 0,
      is_gst_applicable: 0,
      gstin: "",
      gst_rate: 0,
      pan_card_no: "",
      mis_email: "",
      billing_email: "",
      operation_email: "",
      api_access: 0,
      sac_code: "",
      credit_days: 0,
      credit_limit: 0,
      address: "",
      pincode: 0,
      createdAt: "",
      updatedAt: "",
      lead_id: 0,
      pre_lead_id: 0,
      pincode_data: {
        id: 0,
        pincode: 0,
        district: {
          district_name: "",
          state: {
            state_name: "",
          },
        },
      },
    },
  },
  activityListPageCount: 0,
};

export default function activityReducer(state = initialState, action: ActivityActionTypes): IActivityInitialState {
  switch (action.type) {
    case ActivityActions.SET_ACTIVITY_LIST:
      return {
        ...state,
        activityList: action.payload,
      };

    case ActivityActions.SET_ACTIVITY_LIST_PAGE_COUNT:
      return {
        ...state,
        activityListPageCount: action.payload,
      };

    case ActivityActions.SET_ACTIVITY_DATA_BY_ID:
      return {
        ...state,
        activityData: action.payload,
      };

    default:
      return state;
  }
}
